import { useQuery } from '@tanstack/react-query';
import { marketplaceService } from '../services/marketplaceService';

export function useTrailConnectPulse() {
  return useQuery({
    queryKey: ['trailconnect', 'pulse'],
    queryFn: () => marketplaceService.getTrailConnectPulse(),
    refetchInterval: 60_000,
    staleTime: 55_000,
  });
}
